import React from 'react';
import { larguras } from './calculos';
import { formataNumero } from './formata';
import './painel.css';

// Barra horizontal empilhada em ESCALA ABSOLUTA: todas as barras do bloco
// recebem o mesmo `max`, então o comprimento compara tamanho entre linhas.
// A primeira série fica junto do zero (todas as barras de força começam na
// mesma linha). Os números ficam nas colunas ao lado; a barra é a forma.
export default function BarraEmpilhada({ partes, series, max, rotulo, hero }) {
  const ws = larguras(partes, max);
  const descricao = series.map((s, i) => `${s.rotulo} ${formataNumero(partes[i])}`).join(', ');
  return (
    <div
      className={`painel-barra${hero ? ' painel-barra--hero' : ''}`}
      role="img"
      aria-label={rotulo ? `${rotulo}: ${descricao}` : descricao}
      title={descricao}
    >
      {ws.map((w, i) => (
        <span key={series[i].rotulo} className={series[i].classe} style={{ width: `${w}%`, background: series[i].cor }} />
      ))}
    </div>
  );
}
